import { createControlComponent } from "@react-leaflet/core";
import { Control, ControlOptions } from "leaflet";
import { Scale } from "./Scale";

export const MeterScaleControl = createControlComponent<
    Control,
    { ppm: number } & ControlOptions
>((props) => new Scale(props));
